module.exports = __webpack_public_path__ + "static/img/nutrenaklientportal.86be740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nutrenaklientportal.png
// module id = 665
// module chunks = 1